// Imports
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components/macro';
import TopPortion from './top-portion';


// Styled components
const Container = styled.div<{ minHeight: number }>`
	min-height: ${({ minHeight }) => minHeight}px;
`;


// Function  component
const MemberSettings: React.FC = () => {
	// Use state
	const [minHeight, setMinHeight] = useState(0);
	
	
	// Function that updates the minimum height
	const updateHeight = (newHeight: number) => {
		if (newHeight > minHeight) {
			setMinHeight(newHeight);
		}
	};
	
	
	// Return JSX
	return (
		<React.Fragment>
			<TopPortion />
			
			<Container minHeight={minHeight}>
				<Outlet context={updateHeight} />
			</Container>
		</React.Fragment>
	);
};

export default MemberSettings;
